import { createInstance, enums, setLogger, setLogLevel } from '@optimizely/optimizely-sdk';
import { getURLParamValue } from './_getURLParamValue'

function getFeatureFlagVariation(featureFlagName){
  if(window.optiUser && typeof window.optiUser === 'object'){
	  try{
		  let decision = window.optiUser.decide(featureFlagName?.trim()?.toLowerCase());
		  return decision?.variationKey || 'Not Found';
	  }catch(e){
		  console.log(e);
	  }
  }
  return 'Not Found';
}


function createOptiUser(){
  if(window.optiUser === null || window.optiUser === undefined){
    //set optimizely logging 
    if(window.adobeRecsDebug === 'true'){
      setLogLevel('debug');
    }else{
      setLogger(null);
    }

    const dataFileOpts = {};
    dataFileOpts.autoUpdate = true;
    dataFileOpts.updateInterval = 300000; //5mins

    let optiInstance =  createInstance({
      sdkKey: (window.location.host === 'www.dillards.com') ? 'LBGfwqspT8NVr91gGPLQR' : 'CUvMnjEhDucmbQx4CuJAn',
      datafileOptions: dataFileOpts,
      datafile: (window.optimizelyDataFile) ? window.optimizelyDataFile : ''
    });

    // Add Notification Listener
    const notificationId = optiInstance.notificationCenter.addNotificationListener(
      enums.NOTIFICATION_TYPES.DECISION, sendFeatureFlagAnalytics
    );
	
    if(optiInstance){
      let attributes = {};
      let isDillardsUser = false;

      try{
        if(window.sessionStorage && typeof window.sessionStorage === 'object' && sessionStorage.getItem('isDillardsUser')){
    	  isDillardsUser = sessionStorage.getItem('isDillardsUser')?.toLowerCase() === 'true';
        }
      }catch(e){
        console.log(e);
      }

      try{
        attributes.isMobile = window.isMobile;
        attributes.isDillardsUser = (isDillardsUser || window.isDillardsUser?.indexOf("|" + (dataLayer?.user?.userId || '') + "|") > -1);
        attributes.URL = window.location.href.split(getURLParamValue('krypto')).join('');
      }catch(e){ console.log(e); }
      window.optiUser = optiInstance.createUserContext(Dillards.getDdsUUID(), attributes);
    }
  }
}

function sendFeatureFlagAnalytics(data){
	let flagName = data?.decisionInfo?.flagKey;
	let variationKey = data?.decisionInfo?.variationKey;

  if(variationKey && variationKey != 'off'){
    try{
      //Quantum Reporting
      if(typeof QuantumMetricAPI === 'object'){
    	  let qmObj = {
    		"experiment": flagName,
    		"variation": variationKey
    	  };
    	  QuantumMetricAPI.sendEvent(667, 0, qmObj.experiment, qmObj);
      }else{
    	  setTimeout(() => {
    		  if (typeof QuantumMetricAPI === 'object') {
        		  let qmObj = {
        			"experiment": flagName,
        	    	"variation": variationKey
        		  };
    			  QuantumMetricAPI.sendEvent(667, 0, qmObj.experiment, qmObj);
    		  }
    	  }, 1000);
      }
    }catch(e){
      console.log(e);
    }

    try{
      //setting the sessionStorage Object for Adobe Analytics Reporting
      let featureFlagReporting = (sessionStorage.getItem('featureFlagReporting')) ? JSON.parse(sessionStorage.getItem('featureFlagReporting')) : [];

      let thisFF = {};
      thisFF.name = flagName;
      thisFF.value = (variationKey?.toLowerCase().indexOf('expa') > -1) ? (flagName + ' - Control') : (flagName + ' - ' + variationKey);

      featureFlagReporting.push(thisFF);
      sessionStorage.setItem('featureFlagReporting', JSON.stringify(featureFlagReporting))
    }catch(e){
      console.log(e);
    }
	}
}


export {
  createOptiUser,
  getFeatureFlagVariation
}